import React, { useState, useEffect } from 'react';
import { Mail, User, Download, FileDown } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import AttributionBlock from './AttributionBlock';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LeadsView = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchLeads(); }, []);

  const fetchLeads = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get(`${API}/admin/leads`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLeads(response.data.leads || []);
    } catch (error) {
      toast.error('Failed to fetch leads');
    } finally {
      setLoading(false);
    }
  };

  const downloadCsv = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get(`${API}/admin/leads/export.csv`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bizenntrum_leads_${new Date().toISOString().slice(0,10)}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('CSV downloaded');
    } catch (e) {
      toast.error('Failed to download CSV');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  if (loading) return <div className="loading-state">Loading leads...</div>;

  return (
    <div className="consultations-view">
      <div className="view-header">
        <h2>Lead Magnet Downloads</h2>
        <button
          data-testid="leads-csv-btn"
          onClick={downloadCsv}
          className="btn-download-csv"
        >
          <Download size={16} /> Download CSV
        </button>
      </div>

      {leads.length === 0 ? (
        <p className="empty-state">No lead-magnet downloads yet.</p>
      ) : (
        <div className="consultations-list">
          {leads.map((lead) => (
            <div key={lead.id} className="consultation-card" data-testid={`lead-card-${lead.id}`}>
              <div className="consultation-header">
                <div className="consultation-info">
                  <div className="consultation-name">
                    <User size={18} />
                    <strong>{lead.name || lead.email}</strong>
                    <span
                      className="status-badge"
                      style={{ backgroundColor: '#0f766e' }}
                      title={lead.enquiry_type}
                    >
                      <FileDown size={12} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                      {lead.enquiry_type === 'Growth & Market Entry One-Pager' ? 'One-Pager' : '10→100 CFO'}
                    </span>
                  </div>
                  <div className="consultation-meta">
                    <span><Mail size={14} /> {lead.email}</span>
                  </div>
                </div>
              </div>

              <AttributionBlock record={lead} />

              <div className="consultation-footer">
                <div className="consultation-date">
                  Submitted: {formatDate(lead.created_at)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeadsView;
